/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'environments/environment';
import { ColorPickerModule } from 'ngx-color-picker';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthorizedInterceptor } from '../interceptors/authorized.interceptor';
import { HttpsRedirectInterceptor } from '../interceptors/https-interceptor';
import { TokenizerInterceptor } from '../interceptors/tokenizer.interceptor';
import { NgxAuthModule } from './modules/auth/auth.module';
import { NgxMainModule } from './modules/main/main.module';
import { Handler } from './shared/forms-error-notifier/forms-error-notifier.interface';
import { VALIDATION_NOTIFIER_HANDLERS } from './shared/forms-error-notifier/handlers.inject';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ErrorLogInterceptor } from 'interceptors/error-log.interceptor';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot({}),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
      useDefaultLang: true,
    }),
    NgxAuthModule,
    NgxMainModule,
    ColorPickerModule,
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorLogInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: TokenizerInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: AuthorizedInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: HttpsRedirectInterceptor,
    },
    {
      provide: VALIDATION_NOTIFIER_HANDLERS,
      multi: true,
      useValue: {
        executer: () => {},
        selector: () => false,
      } as Handler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
